<template>
  <v-app>
    <ConfirmModal ref="global_confirm_modal" />
    <router-view />
    <tooltip-component />
  </v-app>
</template>

<script>
import Vue from "vue";
import TooltipComponent from "./components/TooltipComponent";
import ConfirmModal from "./components/ConfirmModal";

export default Vue.extend({
  name: "App",
  components: { TooltipComponent, ConfirmModal },
  data: () => ({}),
  created() {
    window.getApp = this;
  },
});
</script>

<style lang="scss">
@import "./assets/styles";
@import "./assets/codeEditor";
</style>
